import React, {useCallback, useState} from 'react';
import {Box, IconButton, Tooltip, Typography} from "@mui/material";
import {AsyncSelect} from "../../../../../components/forms";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import {SubmitHandler, useForm} from "react-hook-form";
import {CLFBDetalle, schemaCLFBDetalle} from "../types/types";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {OperacionCLFBDetalleFields} from "../types/fields";
import {OperacionCLFBLimitesFields} from "../../../types/clfb";


interface SeccionCLFBCampoLimiteProps {
  detalle: CLFBDetalle,
  codPais: number,
  permiteEditar: boolean,
  tipoLimite: 'neto' | 'absoluto',
  handleConfirm: (data: CLFBDetalle) => void
}

const tiposLimites = {
  'neto': HttpCacheOperacion.getLimitesNetos,
  'absoluto': HttpCacheOperacion.getLimitesAbsolutos,
}

function CLFBDetalleCampoLimite({
                                  detalle,
                                  codPais,
                                  permiteEditar,
                                  tipoLimite,
                                  handleConfirm
                                }: SeccionCLFBCampoLimiteProps) {

  const [editable, setEditable] = useState<boolean>(false);

  const {control, handleSubmit} = useForm<CLFBDetalle>({
    resolver: zodResolver(schemaCLFBDetalle),
    defaultValues: {
      ...detalle
    }
  })

  const getLimites = useCallback(() =>
      tiposLimites[tipoLimite](codPais)
    , [codPais])

  const onUpdateDetalle: SubmitHandler<CLFBDetalle> = (data) => {
    handleConfirm(data)
  }

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
      {
        (permiteEditar && editable) ?
          <AsyncSelect
            control={control}
            name={tipoLimite === 'neto' ? OperacionCLFBDetalleFields.CreditLimitNeto : OperacionCLFBDetalleFields.CreditLimitAbsoluto}
            label={`Límite ${tipoLimite === 'neto' ? 'Neto' : 'Absoluto'}`}
            fullWidth
            optionPrefix={"USD "}
            selectNotNulleable
            loadOptions={getLimites}
            valueField={OperacionCLFBLimitesFields.LimiteImporte}
          />
          :
          <Typography noWrap variant='body2'>
            {numberFormatter.toStringWithAmount(detalle[tipoLimite === 'neto' ? OperacionCLFBDetalleFields.CreditLimitNeto : OperacionCLFBDetalleFields.CreditLimitAbsoluto], 'USD ', 0, 0)}
          </Typography>
      }
      {
        permiteEditar &&
        (
          editable ?
            <Box display='flex' justifyContent='center' flexWrap='nowrap'>
              <Tooltip title='Cancelar'>
                <IconButton onClick={() => setEditable(false)}>
                  <CancelIcon color='error'/>
                </IconButton>
              </Tooltip>
              <Tooltip title='Confirmar'>
                <IconButton onClick={handleSubmit(onUpdateDetalle)}>
                  <CheckCircleIcon color='success'/>
                </IconButton>
              </Tooltip>
            </Box>
            :
            <Tooltip title='Editar'>
              <IconButton onClick={() => setEditable(true)}>
                <EditIcon color='info'/>
              </IconButton>
            </Tooltip>
        )
      }
    </Box>
  )
}

export default CLFBDetalleCampoLimite;